import optimizely from '@optimizely/optimizely-sdk';

const optimizelyStrategy = optimizely.createInstance({
  sdkKey: window.pageParams?.optimizelySdkKey,
});

export default class OptimizelyStrategy {
  constructor(user) {
    this.user = user;
  }

  static build(user) {
    return new OptimizelyStrategy(user);
  }

  async isFeatureEnabled(featureKey) {
    return await optimizelyStrategy.onReady().then(() => {
      return optimizelyStrategy.isFeatureEnabled(featureKey, this.user);
    });
  }

  async getVariationByExperiment(experimentKey) {
    return await optimizelyStrategy.onReady().then(() => {
      return optimizelyStrategy.getVariation(experimentKey, this.user);
    });
  }

  track(eventName) {
    optimizelyStrategy.track(eventName, this.user);
  }
}
